export default __webpack_public_path__ + "static/media/twitter.6eb80124.svg";